export const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const result = reader.result as string | null;
      if (!result) {
        reject(new Error('Bestand kon niet gelezen worden'));
        return;
      }

      resolve(result.includes(',') ? result.split(',')[1] : result);
    };

    reader.onerror = () => {
      reject(reader.error ?? new Error('Bestand kon niet gelezen worden'));
    };

    reader.readAsDataURL(file);
  });
